module.exports = __webpack_public_path__ + "img/clip-e-mail-marketing-campaign.1c61fee9.png";